import { toast } from 'react-toastify';

export function renderAlertModal(error) {
  toast.error(error, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: true,
  });
}
